import FirestoreUsageDashboard from "./FirestoreUsageDashboard";

export default function FirebaseUsageScreen() {
  return (
    <div style={{ padding: 24, background: "#0f0f13", minHeight: "100vh", color: "#fff" }}>
      <h1 style={{ marginTop: 0, marginBottom: 20, color: "#6c63ff" }}>Firebase Usage</h1>
      <FirestoreUsageDashboard />
    </div>
  );
}
